import script from "./constactUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./constactUs.vue?vue&type=script&lang=ts&setup=true"

import "./constactUs.vue?vue&type=style&index=0&id=4d3e9ec6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3e9ec6"]])

export default __exports__